import React from 'react';
import { Input } from 'semantic-ui-react';
import { HookFieldSet } from './HookFieldSet';
import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import { useIntl } from 'react-intl';

import { useWizardFormController } from '../wizard/formHelpers';
import { localeData } from '../../../locales/data';
import { WizardControllerProps } from './types';

interface InputFieldProps {
  // copy of FieldProps and InputProps src/components/FormsConnect/types.ts
  inputProps: {
    label?: string;
    id?: string;
    autoFocus?: boolean;
    disabled?: boolean;
    tabIndex?: number;
    modifiers?: string[];
    name: string;
    required?: boolean;
    pathValue: string[];
    pathErrors: string[];
    placeholder?: string;
    type?: string;
    info?: string;
    autocomplete?: string;
    onBlur?(e?: FocusEvent): void;
    noValidate?: boolean;
  };
  controllerProps: WizardControllerProps;
  transformInput?: (value: any) => string;
  transformOutput?: (value: string) => any;
  className?: string;
  errorValues?: any;
}

const transformStub = (value: any) => value;

export const InputField = ({
  inputProps,
  controllerProps,
  transformInput = transformStub,
  transformOutput = transformStub,
  errorValues,
}: InputFieldProps) => {
  const { label, required, modifiers, type, autoFocus, disabled, placeholder, info, noValidate, autocomplete } = inputProps;
  const { name } = controllerProps;
  const controller = useWizardFormController({ ...controllerProps });
  const intl = useIntl();

  const onChange = ({ target: { value } }: any) => {
    controller.field.onChange({ target: { value: transformOutput(value) } });
  };
  const onBlur = (e: any) => {
    inputProps?.onBlur?.(e);

    controller.field.onBlur(e);
  };

  const value = transformInput(controller.field.value) ?? '';

  return (
    <HookFieldSet
      errorValues={errorValues}
      id={name}
      label={label}
      required={required}
      modifiers={modifiers}
      controller={controller}
      control={controllerProps.control}
    >
      <Input
        ref={controller.field.ref}
        id={name}
        name={name}
        type={type}
        autoFocus={autoFocus}
        className="form__input"
        disabled={disabled}
        {...(placeholder ? { placeholder: formatMessageHelper(intl, placeholder) } : {})}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        noValidate={noValidate}
        autoComplete={autocomplete}
      />

      {!!info && (
        <div className="info_small">
          <FormattedMessageHelper tagName="span" id={info} defaultMessage={localeData.en[info]} />
        </div>
      )}
    </HookFieldSet>
  );
};
